export default {
    name: 'Name',
    tel: 'Telefon',
    save: 'Speichern',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    complete: 'Abschließen',
    loading: 'Laden...',
    telEmpty: 'Bitte Telefonnummer angeben',
    nameEmpty: 'Bitte Ihren Namen eingeben',
    nameInvalid: 'Bitte einen gültigen Namen eingeben',
    confirmDelete: 'Möchten Sie wirklich löschen?',
    telInvalid: 'Bitte eine gültige Telefonnummer eingeben',
    vanCalendar: {
        end: 'Ende',
        start: 'Anfang',
        title: 'Titel',
        confirm: 'Bestätigen',
        startEnd: 'Anfang Ende',
        weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    },
    vanCascader: {
        select: 'Bitte auswählen',
    },
    vanContactCard: {
        addText: 'Kontakt hinzufügen',
    },
    vanContactList: {
        addText: 'Neuer Kontakt',
    },
    vanPagination: {
        prev: 'Vorherige Seite',
        next: 'Nächste Seite',
    },
    vanPullRefresh: {
        pulling: 'Zum Aktualisieren ziehen...',
        loosing: 'Zum Aktualisieren loslassen...',
    },
    vanSubmitBar: {
        label: 'Gesamt:',
    },
    vanCoupon: {
        unlimited: 'Unbegrenzte Verwendung',
    },
    vanCouponCell: {
        title: 'Gutschein',
        tips: 'Kann nicht verwendet werden',
    },
    vanCouponList: {
        empty: 'Keine Gutscheine',
        exchange: 'Einlösen',
        close: 'Keine Gutscheine',
        enable: 'Verfügbar',
        disabled: 'Kann nicht verwendet werden',
        placeholder: 'Gutscheincode eingeben',
    },
    vanAddressEdit: {
        area: 'Bereich',
        postal: 'Postleitzahl',
        areaEmpty: 'Bereich auswählen',
        addressEmpty: 'Bitte die genaue Adresse angeben',
        postalEmpty: 'Ungültiges Postleitzahlenformat',
        defaultAddress: 'Als Standard-Lieferadresse festlegen',
        telPlaceholder: 'Telefonnummer des Empfängers',
        namePlaceholder: 'Name des Empfängers',
        areaPlaceholder: 'Provinz/Stadt/Gebiet auswählen',
    },
    vanAddressEditDetail: {
        label: 'Adresse',
        placeholder: 'Straße, Hausnummer, Etage, Zimmer usw.',
    },
    vanAddressList: {
        add: 'Adresse hinzufügen',
    },
};
